import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { ApiError } from 'api/core/ApiError';
import { DailyNavService } from 'api/services/DailyNavService';
import { DAILY_NAV_RECORDS_BY_FIRM_QUERY_KEY } from 'common/constants/services/firms';
import { UpdateDailyNavRecordParams } from './useUpdateDailyNavRecord.types';

const useUpdateDailyNavRecord = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: ({ id, data }: UpdateDailyNavRecordParams) => DailyNavService.apiDailyNavPartialUpdate(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DAILY_NAV_RECORDS_BY_FIRM_QUERY_KEY] });
      enqueueSnackbar('Daily NAV record updated.', { variant: 'success' });
    },
    onError: (error: unknown) => {
      let message = 'Failed to update Daily NAV record.';
      if (error instanceof ApiError && typeof error.body === 'object' && error.body) {
        const { detail } = error.body as Record<string, unknown>;
        if (typeof detail === 'string') {
          message = detail;
        }
      } else if (error instanceof Error && error.message) {
        message = error.message;
      }
      enqueueSnackbar(message, { variant: 'error' });
    },
  });
};

export default useUpdateDailyNavRecord;
